<template>
<div id="entry-view">
  <div class="vx-col w-full mb-base">
     <ValidationObserver v-slot="{ handleSubmit }">
      <vx-card ref="infoCard" :title="$t('KPU.Edit')" title-color="black" 
        :previous-card-action="activeTabIndex > 0" 
        next-card-action 
        save-card-action 
        remove-card-action 
        @remove="returnToList()" 
        @next="next()"
        @previous="previous()"
        @save="handleSubmit(submitData)" >
        
         <form-wizard
            ref="wizard"
            color="rgba(var(--vs-primary), 1)"
            errorColor="rgba(var(--vs-danger), 1)"
            :title="null"
            :subtitle="null"
            :nextButtonText="$t('Next')"
            :backButtonText="$t('Back')"
            :finishButtonText="$t('Submit')"
            @on-complete="handleSubmit(submitData)"
          >
          <tab-content :title="$t('KPU.Tab1')" icon="feather icon-settings" class="mb-2" :before-change="validateStep1">
            <ValidationObserver ref="step1Observer" >
              <div class="p-6">
                <vs-row class="mb-3">
                  <vs-col vs-w="6" class="mr-5">
                    <validated-input
                      :label="$t('KPU.Project')"
                      v-model="kpuProjectName"
                      :disabled="true"
                    ></validated-input>
                  </vs-col>
                  <vs-col vs-w="5">
                    <form-label>{{$t('KPU.ProjectLeader')}}</form-label>
                    <ValidationProvider :name="$t('KPU.ProjectLeader')" rules="required" v-slot="{ errors }">
                      <v-select
                        label="displayName"
                        :options="projectLeaders"
                        v-model="kpuProjectLeader"
                        :reduce="qp => qp.userPrincipalName"
                        class="w-full"
                      />
                      <validation-message>{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                </vs-row>
                <vs-row class="mb-3">
                  <vs-col vs-w="12">
                    <form-label>{{$t('KPU.StatusSummary')}} </form-label>
                    <vs-textarea 
                    v-model="kpuStatusSummary" 
                    class="w-full"  
                    height="300px"
                    name="stautsSummary" />
                  </vs-col>
                </vs-row> 
              </div>
            </ValidationObserver>
          </tab-content >
          <tab-content :title="$t('KPU.Tab2')"  icon="feather icon-dollar-sign" class="mb-2" :before-change="validateStep2">
             <ValidationObserver ref="step2Observer" >
              <div class="p-6">
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="12" class="mr-5 border-right">
                    <h6>{{ $t('KPU.Economics') }}</h6> 
                    <vs-row class="mt-3 mb-3">
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.GoldPrice' )" rules="required|decimal:2|between:0,3000" v-slot="{ errors }">
                          <economic-input
                            v-model="kpuGoldPrice"
                            :precision="2"
                            :previous="kpuPreviousGoldPrice"
                            :label="$t('KPU.GoldPrice')"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      
                      </vs-col>
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.ExchangeRate')" rules="required|decimal:2|between:0,10" v-slot="{ errors }">
                          <economic-input
                            v-model="kpuExchangeRate"
                            :precision="2"
                            :previous="kpuPreviousExchangeRate"
                            :label="$t('KPU.ExchangeRate')"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3">
                        <vx-tooltip :text="$t('KPU.InitialCapexTooltip')" position="bottom" delay=".3s">
                          <form-label>{{$t('KPU.InitialCapex')}} </form-label>
                          <feather-icon icon="InfoIcon" class="cursor-pointer ml-2" svg-classes="h-4 w-4"  />
                        </vx-tooltip>
                        <ValidationProvider :name="$t('KPU.InitialCapex' )" rules="required|numeric|min_value:1" v-slot="{ errors }">
                          <economic-input
                              currencySymbol="M$"
                              v-model="kpuInitialCapexM"
                              :previous="kpuPreviousInitialCapexM"
                            />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mb-3">
                       <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.AnnualProductionOz' )" rules="required|numeric|min_value:0" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.AnnualProductionOz')"
                            v-model="kpuAnnualProductionOz"
                            :previous="kpuPreviousAnnualProductionOz"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      
                      </vs-col>
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.TotalProductionOz' )" rules="required|numeric|min_value:0" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.TotalProductionOz')"
                            v-model="kpuTotalProductionOz"
                          :previous="kpuPreviousTotalProductionOz"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                       <vs-col vs-w="3" >
                        <ValidationProvider :name="$t('KPU.ProductionStartUpDate' )" rules="required|numeric|between:2020,2060" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.ProductionStartUpDate')"
                            v-model="kpuProductionStartUpDate"
                            :useThousandSeparator="false"
                            :previous="kpuPreviousProductionStartUpDate"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mb-3">
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.MineLifeYears' )" rules="required|numeric|between:0,100" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.MineLifeYears')"
                            v-model="kpuMineLifeYears"
                            :previous="kpuPreviousMineLifeYears"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3" class="mr-5">
                        <vx-tooltip :text="$t('KPU.CostToFirstOunceTooltip')" position="bottom" delay=".3s">
                          <form-label>{{$t('KPU.CostToFirstOunce')}} </form-label>
                          <feather-icon icon="InfoIcon" class="cursor-pointer ml-2" svg-classes="h-4 w-4"  />
                        </vx-tooltip>
                        <ValidationProvider :name="$t('KPU.CostToFirstOunce')" rules="required|numeric|min_value:0" v-slot="{ errors }">
                          <economic-input
                            currencySymbol="M$"
                            v-model="kpuCostToFirstOunceM"
                            :previous="kpuPreviousCostToFirstOunceM"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3">
                          <ValidationProvider :name="$t('KPU.CashCost')" rules="required|numeric|min_value:0" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.CashCost')"
                            v-model="kpuCashCost"
                          :previous="kpuPreviousCashCost"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mb-3">
                      <vs-col vs-w="3" class="mr-5" >
                        <ValidationProvider :name="$t('KPU.AISC')" rules="required|numeric|min_value:0" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.AISC')"
                            v-model="kpuAISC"
                            :previous="kpuPreviousAISC"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      
                      </vs-col>
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.NPVAfterTax')" rules="required|decimal" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.NPVAfterTax')"
                            currencySymbol="M$"
                            v-model="kpuNPVAfterTaxM"
                            :previous="kpuPreviousNPVAfterTaxM"
                            :minus="true"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3" >
                        
                         <ValidationProvider :name="$t('KPU.IRRAfterTax')" rules="required|decimal|between:-100,100" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.IRRAfterTax')"
                            v-model="kpuIRRAfterTax"
                            :previous="kpuPreviousIRRAfterTax"
                            :minus="true"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mb-3">
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.StandardFXRate')" rules="required|decimal:2|min_value:0" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.StandardFXRate')"
                            v-model="kpuStandardFXRate"
                            :precision="2"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3">
                        <ValidationProvider :name="$t('KPU.StandardGoldPrice' )" rules="required|decimal:2|min_value:0" v-slot="{ errors }">
                        <economic-input
                            :label="$t('KPU.StandardGoldPrice')"
                            v-model="kpuStandardGoldPrice"
                            :precision="2"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mb-3">
                      <vs-col vs-w="3" class="mr-5">
                        <ValidationProvider :name="$t('KPU.NPVStandard')" rules="required|decimal" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.NPVStandard', {goldPrice : kpuStandardGoldPrice, fxRate : kpuStandardFXRate})"
                            v-model="kpuNPVStandardM"
                            currencySymbol="M$"
                            :previous="kpuPreviousNPVStandardM"
                            :minus="true"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3">
                        <ValidationProvider :name="$t('KPU.IRRStandard' )" rules="required|decimal|between:-100,100" v-slot="{ errors }">
                        <economic-input
                            :label="$t('KPU.IRRStandard', {goldPrice : kpuStandardGoldPrice, fxRate : kpuStandardFXRate})"
                            v-model="kpuIRRStandard"
                            :previous="kpuPreviousIRRStandard"
                            :minus="true"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-lg="4" vs-sm="12">
                    <vx-tooltip class="mb-3" :text="$t('KPU.YearlyCashFlowsTooltip')" position="bottom" delay=".3s">
                      <span clas="h6">{{ $t('KPU.YearlyCashFlows') }}</span>
                      <feather-icon icon="InfoIcon" class="cursor-pointer ml-2" svg-classes="h-4 w-4"  />
                    </vx-tooltip>
                    <vs-row class="mb-3" :data="row" :key="indexRow" v-for="(row, indexRow) in kpuYearlyCashFlows">
                      <vs-divider v-if="indexRow !== 0" class="mb-2"></vs-divider>
                      <vs-col vs-w="1" class="mr-10">
                        <h6 class="mt-10">{{ row.year }}</h6>
                      </vs-col>
                      <vs-col vs-w="4" class="mr-5">
                        <ValidationProvider :name="$t('KPU.CashFlow' )" rules="required|decimal" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.CashFlow')"
                            currencySymbol="M$"
                            v-model="row.value"
                            :minus="true"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="4">
                        <ValidationProvider :name="$t('KPU.CumulativeCashFlow')" rules="required|decimal" v-slot="{ errors }">
                          <economic-input
                            :label="$t('KPU.CumulativeCashFlow')"
                            currencySymbol="M$"
                            v-model="row.cumulativeValue"
                            :minus="true"
                          />
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-w="1"  vs-type="flex" vs-justify="flex-end" vs-align="center" >
                    <feather-icon icon="ClockIcon" class="p-5 bg-primary inline-flex rounded-full text-white shadow" svgClasses="w-5 h-5" @click="showEconomicTimeline" />
                  </vs-col>
                </vs-row>
              </div>
             </ValidationObserver>
          </tab-content>
          <tab-content :title="$t('KPU.Tab3')" icon="feather icon-clipboard" class="mb-2" >
            <todo
              divId="todoDisciplines"
              :tasks="kpuDisciplinesTasks"
              :allowDelete="false"
              :allowComplete="false"
              :allowAdd="false"
              :canEditTitle="false"
              :displayFilters="false"
              @edit="onDisciplineEdited"
              @viewHistory="showTimeline" />
          </tab-content>
          <tab-content :title="$t('KPU.Tab4')" icon="feather icon-alert-triangle" class="mb-2" >
            <todo
              divId="todoChallenge"
              :tasks="kpuChallengesTasks"
              :addText="$t('KPU.Challenges.Add')"
              :editText="$t('KPU.Challenges.Edit')"
              @edit="onChallengeEdited"
              @add="onChallengeAdded"
              @delete="onChallengeDeleted"
              @viewHistory="showTimeline" />
          </tab-content>
          <tab-content :title="$t('KPU.Tab5')" icon="feather icon-flag" class="mb-2" >
            <todo
              divId="todoMilestone"
              :tasks="kpuMilestonesTasks"
              :addText="$t('KPU.Milestones.Add')"
              :editText="$t('KPU.Milestones.Edit')"
              :displayDueDate="true"
              @edit="onMilestoneEdited"
              @add="onMilestoneAdded"
              @delete="onMilestoneDeleted"
              @viewHistory="showTimeline" />
          </tab-content>
          <tab-content :title="$t('KPU.Tab6')" icon="feather icon-zap" class="mb-2" >
            <todo
              divId="todoOpportunity"
              :tasks="kpuOpportunitiesTasks"
              :addText="$t('KPU.Opportunities.Add')"
              :editText="$t('KPU.Opportunities.Edit')"
              :displayStatus="false"
              @edit="onOpportunityEdited"
              @add="onOpportunityAdded"
              @delete="onOpportunityDeleted"
              @viewHistory="showTimeline" />
          </tab-content> 
          <tab-content :title="$t('KPU.Tab7')" icon="feather icon-folder" class="mb-2" >
            <a v-if="kpuProjectDocumentUrl" target="_blank" :href="kpuProjectDocumentUrl">{{ $t('KPU.OpenDocumentLibrary') }}</a>
            <span v-else>{{ $t('KPU.NoDocumentLibrary') }}</span>
          </tab-content>
        </form-wizard>
       </vx-card>
    </ValidationObserver>
  </div>
  <vs-popup class="timelinePopup" :title="$t('KPU.Timeline')" :active.sync="timelinePopupActive">
    <vx-timeline :data="timelineData" />
  </vs-popup>
   <vs-popup class="economicTimelinePopup" :title="$t('KPU.Timeline')" :active.sync="economicTimelinePopupActive">
    <economicsHistory :histories="economicHistories" />
  </vs-popup>
</div>
</template>

<script>

import router from '../../../router'
import moduleKpu from "./store/moduleKpu.js";
// import draggable from 'vuedraggable'
import vSelect from 'vue-select';
//import disciplineStatuses from './components/disciplinesStatus.vue'
import todo  from "./components/Todo.vue";
import economicsHistory from "./components/economicsHistory.vue";
import economicInput from "./components/economicInput.vue";

import VxTimeline from '@/components/timeline/VxTimeline'
import { FormWizard, TabContent } from "vue-form-wizard";
import { v4 as uuidv4} from 'uuid';
import {
  ValidatedInput,
  ValidationMessage,
  FormLabel
} from "../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    vSelect,
    // disciplineStatuses,
    economicsHistory,
    economicInput,
    VxTimeline,
    todo,
    FormWizard, 
    TabContent 
  },
  data() {
    return {
      selected: [],
      activeTabIndex: 0,
      kpuId: 0,
      kpuKeyProjectId: null,
      kpuProjectName: "",
      kpuProjectDocumentUrl : "",
      kpuProjectLeader: "",
      kpuStatusSummary : "",
      kpuGoldPrice: 0,
      kpuAnnualProductionOz: 0,
      kpuTotalProductionOz: 0,
      kpuProductionStartUpDate: 0,
      kpuMineLifeYears: 0,
      kpuInitialCapex: 0,
      kpuExchangeRate: 0,
      kpuCostToFirstOunce: 0,
      kpuCashCost: 0,
      kpuAISC: 0,
      kpuIRRStandard: 0,
      kpuIRRAfterTax: 0,
      kpuNPVAfterTax: 0,
      kpuNPVStandard: 0,
      kpuStandardFXRate: 1.3,
      kpuStandardGoldPrice : 1500,
      kpuPreviousGoldPrice: 0,
      kpuPreviousAnnualProductionOz: 0,
      kpuPreviousTotalProductionOz: 0,
      kpuPreviousProductionStartUpDate: 0,
      kpuPreviousMineLifeYears: 0,
      kpuPreviousInitialCapex: 0,
      kpuPreviousExchangeRate: 0,
      kpuPreviousCostToFirstOunce: 0,
      kpuPreviousCashCost: 0,
      kpuPreviousAISC: 0,
      kpuPreviousIRRStandard: 0,
      kpuPreviousIRRAfterTax: 0,
      kpuPreviousNPVAfterTax: 0,
      kpuPreviousNPVStandard: 0,
      kpuPreviousStandardFXRate: 0,
      kpuPreviousStandardGoldPrice : 0,
      kpuYearlyCashFlows : [],
      kpuDisciplines : [],
      kpuChallenges : [],
      kpuMilestones : [],
      kpuOpportunities : [],
      selectedTab: 0,
      timelinePopupActive: false,
      timelineData: [],
      economicTimelinePopupActive: false,
      economicHistories : []
    };
  },
  computed: {
    projectLeaders() {
      return this.$store.state.kpu.projectLeaders;
    },
    kpuDisciplinesTasks() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sortedDiscipline = this.kpuDisciplines.sort((a, b) => { return a.disciplineType - b.disciplineType });
      return sortedDiscipline.map(obj => {
        return {
          id: parseInt(obj.disciplineType),
          uniqueId : parseInt(obj.disciplineType).toString(),
          name:  this.$t('KPU.Discipline.' + obj.disciplineType),
          desc : obj.comments === null ? '' : obj.comments,
          status : obj.status,
          histories : obj.histories
        }
      })
    },
    kpuChallengesTasks() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sortedChallenges = this.kpuChallenges.sort(this.compareNames);
      return sortedChallenges.map(obj => {
        return {
          id: obj.id,
          uniqueId : obj.uniqueId,
          name: obj.name,
          desc : obj.comments,
          status : obj.status,
          isCompleted : obj.isCompleted,
          isTrashed : obj.isDeleted,
          histories : obj.histories
        }
      })
    },
    kpuMilestonesTasks() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sortedMilestones = this.kpuMilestones.sort(this.compareNames);
      return sortedMilestones.map(obj => {
        return {
          id: obj.id,
          uniqueId : obj.uniqueId,
          name: obj.name,
          desc : obj.comments,
          dueDate : obj.dueDate,
          status : obj.status,
          isCompleted : obj.isCompleted,
          isTrashed : obj.isDeleted,
          histories : obj.histories
        }
      })
    },
    kpuOpportunitiesTasks() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sortedOpportunities = this.kpuOpportunities.sort(this.compareNames);
      return sortedOpportunities.map(obj => {
        return {
          id: obj.id,
          uniqueId : obj.uniqueId,
          name: obj.name,
          desc : obj.comments,
          isCompleted : obj.isCompleted,
          isTrashed : obj.isDeleted,
          histories : obj.histories
        }
      })
    },
    kpuPreviousInitialCapexM() {
      return this.kpuPreviousInitialCapex / 1000000;
    },
    kpuPreviousCostToFirstOunceM() {
      return this.kpuPreviousCostToFirstOunce / 1000000;
    },
    kpuPreviousNPVAfterTaxM() {
      return this.kpuPreviousNPVAfterTax / 1000000;
    },
    kpuPreviousNPVStandardM() {
      return this.kpuPreviousNPVStandard / 1000000;
    },
    kpuInitialCapexM : {
      get() {
        return this.kpuInitialCapex / 1000000;
      },
      // setter
      set(newValue) {
        this.kpuInitialCapex = newValue * 1000000;
      }
    },
    kpuCostToFirstOunceM : {
      get() {
        return this.kpuCostToFirstOunce / 1000000;
      },
      // setter
      set(newValue) {
        this.kpuCostToFirstOunce = newValue * 1000000;
      }
    },
    kpuNPVAfterTaxM : {
      get() {
        return this.kpuNPVAfterTax / 1000000;
      },
      // setter
      set(newValue) {
        this.kpuNPVAfterTax = newValue * 1000000;
      }
    },
    kpuNPVStandardM : {
      get() {
        return this.kpuNPVStandard / 1000000;
      },
      // setter
      set(newValue) {
        this.kpuNPVStandard = newValue * 1000000;
      }
    }
  },
  created() {
    if (!moduleKpu.isRegistered) {
      this.$store.registerModule("kpu", moduleKpu);
      moduleKpu.isRegistered = true;
    }

    if (this.$route.params.editData !== undefined && this.$route.params.editData !== null) {
      this.kpuKeyProjectId = this.$route.params.editData.keyProjectId;
      this.refreshModel();
    } else if (this.$route.query.keyProjectId !== null) {
      this.kpuKeyProjectId = this.$route.query.keyProjectId;
      this.refreshModel();
    }
  },
  mounted() {
    this.$refs.wizard.activateAll();

    if (this.$store.state.kpu.projectLeaders.length === 0) {
      this.$vs.loading();

      this.$store.dispatch("kpu/fetchProjectLeaders").finally(() => {
        this.$vs.loading.close();
      })
    } 
  },
  methods: {
    next() {
      this.$refs.wizard.nextTab();
      this.activeTabIndex++;
    },
    previous() {
      this.$refs.wizard.prevTab();
      this.activeTabIndex--;
    },
    
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.step1Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$refs.step2Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    compareNames(a, b) {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return 0;
    },
    refreshModel() {
      this.$vs.loading();
      this.getKpu().finally(() => {
        this.$vs.loading.close();
      })
    },

    initializeKpuUniqueId() {
      this.kpuChallenges.forEach(challenge => {
        challenge.uniqueId = uuidv4();
      });

      this.kpuMilestones.forEach(milestone => {
        milestone.uniqueId = uuidv4();
      })

      this.kpuOpportunities.forEach(opportunity => {
        opportunity.uniqueId = uuidv4();
      })
    },


    getKpu() {
      return new Promise((resolve, reject) => {
        this.$webApi.get("cashflow/kpu/getEditableKPU/" + this.kpuKeyProjectId).then((response) => {
          this.kpuId = response.data.id;
          this.kpuProjectLeader = response.data.projectLeader;
          this.kpuKeyProjectId = response.data.keyProjectId;
          this.kpuProjectDocumentUrl = response.data.keyProject.documentLibraryUrl;
          this.kpuProjectName = response.data.keyProject.projectName;
          this.kpuStatusSummary = response.data.statusSummary;
          this.kpuGoldPrice = response.data.goldPrice;
          this.kpuExchangeRate = response.data.exchangeRate;
          this.kpuAnnualProductionOz = response.data.annualProductionOz;
          this.kpuCostToFirstOunce = response.data.costToFirstOunce;
          this.kpuTotalProductionOz = response.data.totalProductionOz;
          this.kpuCashCost = response.data.cashCost;
          this.kpuProductionStartUpDate = response.data.productionStartUpDate;
          this.kpuAISC = response.data.aisc;
          this.kpuMineLifeYears = response.data.mineLifeYears;
          this.kpuIRRAfterTax = response.data.irrAfterTax;
          this.kpuInitialCapex = response.data.initialCapex;
          this.kpuNPVAfterTax = response.data.npvAfterTax;
          this.kpuIRRStandard = response.data.irrStandard;
          this.kpuNPVStandard = response.data.npvStandard;
          this.kpuStandardGoldPrice = response.data.standardGoldPrice;
          this.kpuStandardFXRate = response.data.standardFXRate;
          this.kpuYearlyCashFlows = response.data.yearlyCashFlows.sort((a, b) => { return a.year - b.year });
          this.kpuDisciplines = response.data.disciplines;
          this.kpuChallenges = response.data.challenges;
          this.kpuMilestones = response.data.milestones;
          this.kpuOpportunities = response.data.opportunities;
          this.economicHistories = response.data.economicHistories;

          const latestEconomic = this.economicHistories.sort((a, b) => { return new Date(b.submissionTime) - new Date(a.submissionTime) })[0];
          if (latestEconomic !== undefined) { 
            this.kpuPreviousGoldPrice = latestEconomic.goldPrice;
            this.kpuPreviousExchangeRate = latestEconomic.exchangeRate;
            this.kpuPreviousAnnualProductionOz = latestEconomic.annualProductionOz;
            this.kpuPreviousCostToFirstOunce = latestEconomic.costToFirstOunce;
            this.kpuPreviousTotalProductionOz = latestEconomic.totalProductionOz;
            this.kpuPreviousCashCost = latestEconomic.cashCost;
            this.kpuPreviousProductionStartUpDate = latestEconomic.productionStartUpDate;
            this.kpuPreviousAISC = latestEconomic.aisc;
            this.kpuPreviousMineLifeYears = latestEconomic.mineLifeYears;
            this.kpuPreviousIRRAfterTax = latestEconomic.irrAfterTax;
            this.kpuPreviousInitialCapex = latestEconomic.initialCapex;
            this.kpuPreviousNPVAfterTax = latestEconomic.npvAfterTax;
            this.kpuPreviousIRRStandard = latestEconomic.irrStandard;
            this.kpuPreviousStandardFXRate = latestEconomic.standardFXRate;
            this.kpuPreviousStandardGoldPrice = latestEconomic.standardGoldPrice;
            this.kpuPreviousNPVStandard = latestEconomic.npvStandard;
          }


          // adjust yearly Cashflow in Millions
          this.kpuYearlyCashFlows.forEach(yearlyCashFlow => {
            yearlyCashFlow.value = yearlyCashFlow.value / 1000000;
            yearlyCashFlow.cumulativeValue = yearlyCashFlow.cumulativeValue / 1000000;
          });

          this.initializeKpuUniqueId();

          resolve(response)
        }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message  
          });
          reject(error)
        })
      });
    },
    returnToList() {
      router.push("/bsg/kpu/kpus");
    },
    showTimeline(data) {
      this.timelineData = data;
      this.timelinePopupActive = true;
    },
    showEconomicTimeline() {
      this.economicTimelinePopupActive = true;
    },
    onChallengeEdited(todo) {
      const challenge = this.kpuChallenges.find(k => k.uniqueId === todo.uniqueId);
      challenge.name = todo.name;
      challenge.comments = todo.desc;
      challenge.status = todo.status;
      challenge.isCompleted = todo.isCompleted;
    },
    onDisciplineEdited(todo) {
      const discipline = this.kpuDisciplines.find(k => k.disciplineType === parseInt(todo.uniqueId));
      discipline.comments = todo.desc;
      discipline.status = todo.status;
    },
    onChallengeAdded(todo) {
      const challenge = {
        id : 0,
        name : todo.name,
        comments : todo.desc,
        status : todo.status,
        isCompleted : todo.isCompleted,
        isDeleted : false,
        uniqueId : uuidv4(),
        histories : []
      }
      this.kpuChallenges.push(challenge);
    },
    onChallengeDeleted(todo) {
      const challenge = this.kpuChallenges.find(k => k.uniqueId === todo.uniqueId);
      challenge.isDeleted = true;
    },
    onMilestoneEdited(todo) {
      const milestone = this.kpuMilestones.find(k => k.uniqueId === todo.uniqueId);
      milestone.name = todo.name;
      milestone.comments = todo.desc;
      milestone.status = todo.status;
      milestone.dueDate = todo.dueDate;
      milestone.isCompleted = todo.isCompleted;
    },
    onMilestoneAdded(todo) {
      const milestone = {
        id : 0,
        name : todo.name,
        comments : todo.desc,
        status : todo.status,
        dueDate : todo.dueDate,
        isCompleted : todo.isCompleted,
        isDeleted : false,
        uniqueId : uuidv4(),
        histories : []
      }
      this.kpuMilestones.push(milestone);
    },
    onMilestoneDeleted(todo) {
      const milestone = this.kpuMilestones.find(k => k.uniqueId === todo.uniqueId);
      milestone.isDeleted = true;
    },
    onOpportunityEdited(todo) {
      const opportunity = this.kpuOpportunities.find(k => k.uniqueId === todo.uniqueId);
      opportunity.name = todo.name;
      opportunity.comments = todo.desc;
      opportunity.isCompleted = todo.isCompleted;
    },
    onOpportunityAdded(todo) {
      const opportunity = {
        id : 0,
        name : todo.name,
        comments : todo.desc,
        isCompleted : todo.isCompleted,
        isDeleted : false,
        uniqueId : uuidv4(),
        histories : []
      }
      this.kpuOpportunities.push(opportunity);
    },
    onOpportunityDeleted(todo) {
      const opportunity = this.kpuOpportunities.find(k => k.uniqueId === todo.uniqueId);
      opportunity.isDeleted = true;
    },
    submitData() {

      this.$vs.loading();

      // adjust yearly Cashflow in Millions
      this.kpuYearlyCashFlows.forEach(yearlyCashFlow => {
        yearlyCashFlow.value = yearlyCashFlow.value * 1000000;
        yearlyCashFlow.cumulativeValue = yearlyCashFlow.cumulativeValue * 1000000;
      });
   
      const obj = {
        id : this.kpuId,
        keyProjectId : this.kpuKeyProjectId,
        statusSummary : this.kpuStatusSummary,
        projectLeader : this.kpuProjectLeader,
        goldPrice : this.kpuGoldPrice,
        exchangeRate : this.kpuExchangeRate,
        annualProductionOz : this.kpuAnnualProductionOz,
        costToFirstOunce : this.kpuCostToFirstOunce,
        totalProductionOz : this.kpuTotalProductionOz,
        cashCost : this.kpuCashCost,
        productionStartUpDate : this.kpuProductionStartUpDate,
        aisc : this.kpuAISC,
        mineLifeYears : this.kpuMineLifeYears,
        irrAfterTax : this.kpuIRRAfterTax,
        initialCapex : this.kpuInitialCapex,
        npvAfterTax : this.kpuNPVAfterTax,
        irrStandard : this.kpuIRRStandard,
        npvStandard : this.kpuNPVStandard,
        standardGoldPrice : this.kpuStandardGoldPrice,
        standardFXRate : this.kpuStandardFXRate,
        yearlyCashFlows : this.kpuYearlyCashFlows,
        disciplines : this.kpuDisciplines,
        challenges : this.kpuChallenges,
        opportunities : this.kpuOpportunities,
        milestones : this.kpuMilestones
      };

      this.$webApi.post('cashflow/kpu/', obj).then(() => {
        this.$notifySaveSuccess();
        this.$vs.loading.close();
        this.refreshModel();
      })
    }
  }
};
</script>
<style lang="scss">
  .list-scrollable {
    height:500px;/* or any height you want */
    overflow-y:auto;
  }

  .economicTimelinePopup {
    .vs-popup {
      width: 1400px !important;
      height: auto !important;
    }
  }
</style>